import { Switch, Route, useRouteMatch } from 'react-router-dom';
import ChallengeIXProgramme from '@pages/challengeTags/challengeIXProgramme/ChallengeIXProgramme';
import ChallengeTechnology from '@pages/challengeTechnology/ChallengeTechnology';

const ChallengeTagsRoutes: React.FC = () => {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route exact path={`${path}/challenge`}>
                <ChallengeIXProgramme />
            </Route>
            <Route exact path={`${path}/challenge/:action/`}>
                <ChallengeIXProgramme />
            </Route>
            <Route exact path={`${path}/challenge/:action/:id`}>
                <ChallengeIXProgramme />
            </Route>
            <Route exact path={`${path}/business`}>
                <ChallengeTechnology />
            </Route>
            <Route exact path={`${path}/business/:action`}>
                <ChallengeTechnology />
            </Route>
            <Route exact path={`${path}/business/:action/:id`}>
                <ChallengeTechnology />
            </Route>
        </Switch>
    );
};

export default ChallengeTagsRoutes;
